import { colorsForEnergyEfficiency } from '@packages/shared/src/ui/EnergyEfficiencyFlag/colorsForEnergyEfficiency';

export type EfficiencyClass = keyof typeof colorsForEnergyEfficiency;

export const isEfficiencyClass = (value: string | null | undefined): value is EfficiencyClass =>
  !!value && value in colorsForEnergyEfficiency;
